export const COUNTRY_OPTIONS = Object.freeze({
    KR: {
        zone: "Asia/Seoul",
        currency: "KRW",
        dueDateExpirationHour: 20,
    },
    TW: {
        zone: "Asia/Taipei",
        currency: "TWD",
        dueDateExpirationHour: 20,
    },
    HK: {
        zone: "Asia/Hong_Kong",
        currency: "HKD",
        dueDateExpirationHour: 20,
    },
    AU: {
        zone: "Australia/Sydney",
        currency: "AUD",
        dueDateExpirationHour: 20,
    },
    US: {
        zone: "America/New_York",
        currency: "USD",
        dueDateExpirationHour: 20,
    },
    JP: {
        zone: "Asia/Tokyo",
        currency: "JPY",
        dueDateExpirationHour: 20,
    },
    GB: {
        zone: "Europe/London",
        currency: "GBP",
        dueDateExpirationHour: 20,
    },
});

export const SUPPORTED_CURRENCIES = ["EUR", "GBP", "JPY", "KRW", "TWD", "USD"];

export const CURRENCY_OPTIONS = SUPPORTED_CURRENCIES.reduce(
    (options, e) => [...options, { label: e, value: e }],
    [{ label: "Local CCY", value: "" }]
);
